// installer le plugin yarn add cordova-plugin-file-opener2 dans le dossier de l'app
// https://github.com/pwlin/cordova-plugin-file-opener2

import { Logger } from "@core/helpers/logger.helpers";

export class CordovaFileOpener {
  static get plugin() {
    if (CordovaFileOpener.cordovaInstalled() && CordovaFileOpener.cordovaFileOpenerInstalled()) {
      return window.cordova.plugins.fileOpener2;
    }
    Logger.error("### CordovaFileOpener - plugin - not installed");
    return undefined;
  }

  static cordovaInstalled() {
    return window.cordova !== undefined;
  }

  static cordovaFileOpenerInstalled() {
    return window.cordova.plugins.fileOpener2 !== undefined;
  }
}
